(() => {
  const root = document.querySelector('[data-ap2-root]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  root.querySelectorAll('[data-ap2-result]').forEach(panel => {
    if (!panel.querySelector('a[href*="/products/"]')) {
      panel.hidden = true;
      const control = root.querySelector(`[data-ap2-choice="${panel.dataset.ap2Result}"]`);
      if (control) control.hidden = true;
    }
  });
  const track = (event, node, extra = {}) => {
    // Reuse the existing dataLayer; purchase/ATC remains owned by Shopify's successful-cart events.
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({event, logical_collection_id:'aprilskin', module_source:node?.dataset.moduleSource || 'concern', product_id:node?.dataset.productId, ...extra});
  };
  root.addEventListener('click', event => {
    const choice = event.target.closest('[data-ap2-choice]');
    if (choice) {
      const key = choice.dataset.ap2Choice;
      root.querySelectorAll('[data-ap2-result]').forEach(panel => {panel.open = panel.dataset.ap2Result === key;});
      root.querySelectorAll('[data-ap2-choice]').forEach(link => link.setAttribute('aria-expanded',String(link===choice)));
      track('concern_click', choice, {concern:key});
    }
    const link = event.target.closest('a[href*="/products/"]');
    if (link) {
      const card = link.closest('[data-ap2-card]');
      track(link.dataset.ap2Event || 'recommended_product_click',card || link);
    }
  });
  root.querySelectorAll('[data-ap2-result]').forEach(panel => panel.addEventListener('toggle', () => {
    const control=root.querySelector(`[data-ap2-choice="${panel.dataset.ap2Result}"]`);
    control?.setAttribute('aria-expanded',String(panel.open));
  }));
  const catalog=document.querySelector('[data-ap2-catalog]');
  catalog?.addEventListener('change',event=>{
    const input=event.target;
    if(input.name==='sort_by')track('collection_sort_change',null,{module_source:'catalog',sort:input.value});
    else if(input.name?.startsWith('filter.'))track('collection_filter_change',null,{module_source:'catalog',filter:input.name});
  });
})();
